import errors from './errors/index.js';
import translation from './translation/index.js';
const fr = Object.freeze({
    translation,
    errors,
});
export default fr;
